interface TitleProps {
    color?: string;
    className?: string;
}

const CMATitle = ({ color = "#333333", className }: TitleProps) => (
    <svg
        width="128"
        height="44"
        viewBox="0 0 128 44"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
    >
        <path
            d="M94.2886 43.3393H91.4073L107.194 0.719933H111.456L127.424 43.3393H124.482L119.98 31.3939H98.7306L94.2886 43.3393ZM108.935 3.78132L99.6911 28.7527H119.02L109.656 3.78132C109.536 3.42116 109.355 3.00097 109.295 2.70083C109.235 2.94094 109.055 3.48119 108.935 3.78132Z"
            fill={color}
        />
        <path
            d="M49.5515 43.3393H46.6702V0.719933H49.5515L65.8789 39.8577L82.1463 0.719933H85.0876V43.3393H82.2063V19.9887C82.2063 13.0255 82.3264 9.42389 82.5065 6.60261L67.3196 43.3393H64.4382L49.2513 6.78269C49.3714 7.98323 49.5515 12.9655 49.5515 19.9887V43.3393Z"
            fill={color}
        />
        <path
            d="M20.749 44C9.10368 44 1 34.9959 1 22.03C1 9.00409 9.16371 0 20.9891 0C29.693 0 36.7763 5.40246 38.6371 13.5061H35.4557C33.5348 6.90314 27.8922 2.76126 20.809 2.76126C10.7844 2.76126 3.94134 10.5648 3.94134 22.03C3.94134 33.4952 10.7844 41.2387 20.809 41.2387C27.8922 41.2387 33.7149 37.2769 35.6958 31.1542H38.8772C36.8363 38.8377 29.513 44 20.749 44Z"
            fill={color}
        />
    </svg>
);

const PHDTitle = ({ color = "#333333", className }: TitleProps) => (
    <svg
        width="128"
        height="45"
        viewBox="0 0 128 45"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
    >
        <path
            d="M105.781 44.6637H93.6537V1.39496H105.781C118.884 1.39496 127.598 10.0487 127.598 23.0293C127.598 36.0099 118.884 44.6637 105.781 44.6637ZM105.781 4.0764H96.5789V41.9822H105.781C117.177 41.9822 124.612 34.5473 124.612 23.0293C124.612 11.4504 117.299 4.0764 105.781 4.0764Z"
            fill={color}
        />
        <path
            d="M62.0979 44.6031H59.2945V0.664062H62.0979V21.0796C63.9871 17.3012 67.6436 14.6807 72.8236 14.6807C80.6851 14.6807 83.915 19.556 83.915 26.8691V44.6641H81.1117V27.4175C81.1117 19.6779 77.638 17.2402 72.6408 17.2402C65.6325 17.2402 62.0979 22.6031 62.0979 28.7582V44.6031Z"
            fill={color}
        />
        <path
            d="M39.5773 28.3922H26.3529V44.6637H23.4277V1.39496H39.5773C47.8045 1.39496 52.8626 6.75784 52.8626 14.8022C52.8626 22.4199 47.7435 28.3922 39.5773 28.3922ZM39.4554 4.0764H26.3529V25.7108H39.0898C45.8543 25.7108 49.8765 21.1401 49.8765 14.6803C49.8765 8.1595 45.7934 4.0764 39.4554 4.0764Z"
            fill={color}
        />
    </svg>
);

const MDTitle = ({ color = "#333333", className }: TitleProps) => (
    <svg
        width="128"
        height="45"
        viewBox="0 0 128 45"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
    >
        <path
            d="M105.327 44.96H92.9947V0.959961H105.327C118.651 0.959961 127.513 9.75996 127.513 22.96C127.513 36.16 118.651 44.96 105.327 44.96ZM105.327 3.68672H95.9694V42.2332H105.327C116.916 42.2332 124.476 34.6726 124.476 22.96C124.476 11.1853 117.04 3.68672 105.327 3.68672Z"
            fill={color}
        />
        <path
            d="M45.1348 44.96H42.1602V0.959961H45.1348L61.9911 41.3656L78.7855 0.959961H81.8221V44.96H78.8475V20.8529C78.8475 13.6642 78.9714 9.94588 79.1573 7.0332L63.4785 44.96H60.5038L44.8249 7.21912C44.9489 8.45855 45.1348 13.6022 45.1348 20.8529V44.96Z"
            fill={color}
        />
    </svg>
);

const RNTitle = ({ color = "#333333", className }: TitleProps) => (
    <svg
        width="128"
        height="45"
        viewBox="0 0 128 45"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
    >
        <path
            d="M98.9887 44.96H96.014V0.959961H99.0506L124.831 39.9402V0.959961H127.806V44.96H124.831L98.9887 5.85574V44.96Z"
            fill={color}
        />
        <path
            d="M60.1348 44.96H57.1602V0.959961H73.3968C81.763 0.959961 87.0306 5.79376 87.0306 13.2924C87.0306 19.7374 83.4362 24.3233 77.5489 25.5628L87.4024 44.96H84.0559L74.4503 25.9346H60.1348V44.96ZM60.1348 3.68672V23.2078H73.5207C80.1517 23.2078 83.994 19.4895 83.994 13.4163C83.994 7.15715 79.8418 3.68672 73.3968 3.68672H60.1348Z"
            fill={color}
        />
    </svg>
);

const NPTitle = ({ color = "#333333", className }: TitleProps) => (
    <svg
        width="129"
        height="44"
        viewBox="0 0 129 44"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
    >
        <path
            d="M115.391 27.4535H101.943V44H98.9687V0H115.391C123.757 0 128.901 5.45352 128.901 13.6338C128.901 21.3803 123.696 27.4535 115.391 27.4535ZM115.267 2.72676H101.943V24.7268H114.896C121.774 24.7268 125.865 20.0789 125.865 13.5099C125.865 6.87887 121.712 2.72676 115.267 2.72676Z"
            fill={color}
        />
        <path
            d="M58.9746 44H56V0H59.0366L84.8169 38.9803V0H87.7915V44H84.8169L58.9746 4.89577V44Z"
            fill={color}
        />
    </svg>
);

export { CMATitle, PHDTitle, MDTitle, RNTitle, NPTitle };
